import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './messages/en.json'
import nl from './messages/nl.json'
import de from './messages/de.json'
import fr from './messages/fr.json'
import es from './messages/es.json'
import ru from './messages/ru.json'
import tr from './messages/tr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, nl: { translation: nl }, de: { translation: de }, fr: { translation: fr }, es: { translation: es }, ru: { translation: ru }, tr: { translation: tr } },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'de', 'fr', 'es', 'ru', 'tr'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
